import React, { useId } from 'react';

import { Input } from '@src/components/ui';

import FieldShell from './FieldShell';


/**
 * Base text field — label above, input, helper/error line below.
 * Receives RHF field props (value/onChange/onBlur/name/ref) plus
 * `error` (bool) and `helperText` from the generic form wrapper.
 */
const TextField = React.forwardRef((props, ref) => {
  const {
    label,
    value = '',
    error = false,
    suggested = false,
    helperText = ' ',
    className,
    leading = null,
    trailing = null,
    ...restProps
  } = props;

  const generatedId = useId();
  const id = restProps.id || generatedId;

  return (
    <FieldShell
      id={id}
      label={label}
      className={className}
      suggested={suggested}
      helperText={helperText}
      error={error}
    >
      <Input
        ref={ref}
        id={id}
        value={value}
        invalid={error}
        leading={leading}
        trailing={trailing}
        {...restProps}
      />
    </FieldShell>
  );
});

TextField.displayName = 'TextField';
export default TextField;
